export function isSectionHidden(sections, sectionId) {
  if (!sections || sectionId == null || sectionId === '') return false
  const section =
    sections[sectionId] ??
    sections[String(sectionId)] ??
    (typeof sectionId === 'string' && /^\d+$/.test(sectionId)
      ? sections[Number(sectionId)]
      : undefined)
  if (section) return Boolean(section.hidden)
  const target = String(sectionId)
  return Object.values(sections).some(
    (candidate) =>
      candidate?.hidden && String(candidate.sectionId ?? '') === target
  )
}
